import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const fakePrivacyDocumentUpdateUri = apiBaseUrl + '/fakeuploadurl'

export const addFamilyMemberPrivacyDocument = http.post<
  object,
  membershipApi.PrivacyDocumentUploadRequest,
  membershipApi.Document
>(apiBaseUrl + '/familyMembers/:familyMemberId/documents', async ({ request }) => {
  const body = await request.json()

  return HttpResponse.json(
    { url: fakePrivacyDocumentUpdateUri, documentId: 'XXX01', name: body.documentName, type: 'privacy' },
    { status: 201 },
  )
})
